module.exports = __webpack_public_path__ + "img/me.e9b5058a.jpg";